/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-down': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10 17.5a.5.5 0 01-.5-.5V3a.5.5 0 011 0v14a.5.5 0 01-.5.5z" _fill="#1F222C"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M9.646 17.354a.5.5 0 010-.708l6-6a.5.5 0 01.708.708l-6 6a.5.5 0 01-.708 0z" _fill="#1F222C"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M3.646 10.646a.5.5 0 01.708 0l6 6a.5.5 0 01-.708.708l-6-6a.5.5 0 010-.708z" _fill="#1F222C"/>'
  }
})
